import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ClientProfileService, UserService} from "../../_services";
import {WorkstreamService} from "../../_services/workstream.service";
import {ReferenceResourceService} from "../../_services/referemceResource.service";

@Component({
    standalone: false,
  selector: "reference-resources-list",
  templateUrl: 'reference-resources-list.component.html',
  styleUrls: ['./reference-resources-list.component.scss'],
})

export class ReferenceResourcesListComponent implements OnInit {
  users: any;
  list: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public service: ReferenceResourceService,
              public dialogRef: MatDialogRef<ReferenceResourcesListComponent>)
  {
    this.list = data.entity;
  }
  ngOnInit(): void {
  }

  save(): void {
    this.service.saveList(this.list).subscribe(r => this.close());
  }

  close(): void {
    this.dialogRef.close();
  }
}
